module.exports = __webpack_public_path__ + "img/serve-icon.27f6ed4b.png";